import { MenuInterface } from 'src/app/_core/components/layout-nav/routes';

export const contactRoutes: MenuInterface[] = [
    {
        code: 'GestionBenefContacterMail_ViewModel',
        route: [{content: 'contact/contact/mail', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionNewsletterTheme_ViewModel',
        route: [{content: 'contact/models/newsletter/themes/list', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionModeleAdresse_ViewModel',
        route: [{content: 'contact/models/address/list', focus: 'contact/models/address/detail'}, 'content']
    },
    {
        code: 'GestionPublipostageModeleMail_ViewModel',
        route: [{content: 'contact/models/mail/list', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionEnvoiCourrier_ViewModel',
        route: [{content: 'contact/contact/letter', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionPublipostageHistorique_ViewModel',
        route: [{content: 'contact/send-history/list', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionPublipostageModeleCourrier_ViewModel',
        route: [{content: 'contact/models/letter/list', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionBeneficiaireNewsletterEnvoi_ViewModel',
        route: [{content: 'contact/contact/newsletter', focus: 'empty'}, 'content']
    },
    {
        code: 'GestionPublipostageModeleRequete_ViewModel',
        route: [{content: 'contact/request/list', focus: 'empty'}, 'content']
    },
];
